export default __webpack_public_path__ + "static/media/aq.e6c275d0.svg";